module.exports = __webpack_public_path__ + "static/media/annoying-lack-of-bleeding-map.87a1d6be.png";